(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jb-butter-experience"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jb-butter-experience')){
customElements.define('jb-butter-experience',class extends HTMLElement{
 connectedCallback(){
  this.root=document.querySelector('[data-section-id="'+this.dataset.section+'"]');
  if(!this.root)return;
  this.info=this.root.querySelector('.product__info-container');
  this.form=this.root.querySelector('product-form form');
  this.native=this.form?.querySelector('[name="add"]');
  if(!this.info||!this.native)return;
  if(!this.info.querySelector('.jb-pdp-details'))this.info.appendChild(this.querySelector('template').content.cloneNode(true));
  this.bar=this.querySelector('.jb-pdp-sticky');
  this.stickyAdd=this.querySelector('[data-add]');
  this.selection=this.querySelector('[data-selection]');
  this.chips=[];
  this.root.querySelectorAll('variant-selects select').forEach(select=>{
   if(select.options.length<2||select.options.length>6)return;
   const wrap=select.closest('.product-form__input');
   const group=document.createElement('div');
   group.className='jb-pdp-chipset';group.setAttribute('role','group');
   group.setAttribute('aria-label',wrap.querySelector('label')?.textContent.trim()||select.name);
   Array.from(select.options).forEach(option=>{
    const button=document.createElement('button');button.type='button';button.textContent=option.textContent.trim();
    button.dataset.value=option.value;button.setAttribute('aria-pressed',String(select.value===option.value));
    button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));this.sync();});
    group.appendChild(button);
   });
   wrap.appendChild(group);select.closest('.select').classList.add('jb-pdp-native-select');
   this.chips.push({select,group});
  });
  this.onChange=()=>this.sync();
  this.root.addEventListener('change',this.onChange);
  this.stickyAdd.addEventListener('click',()=>{const current=this.root.querySelector('product-form form [name="add"]');if(current&&!current.disabled)current.click();});
  this.querySelector('[data-back]').addEventListener('click',()=>{this.info.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});});
  this.observer=new MutationObserver(()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.sync();});});
  this.observer.observe(this.root,{attributes:true,attributeFilter:['disabled','value'],childList:true,subtree:true});
  this.onScroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.sync();});};
  window.addEventListener('scroll',this.onScroll,{passive:true});this.sync();
 }
 sync(){
  this.native=this.root.querySelector('product-form form [name="add"]');
  if(!this.native)return;
  this.bar.hidden=this.native.getBoundingClientRect().bottom>=0;
  this.chips.forEach(({select,group})=>group.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value))));
  const text=Array.from(this.root.querySelectorAll('variant-selects select')).map(s=>s.selectedOptions[0]?.textContent.trim()).filter(Boolean).join(' · ');
  if(this.selection.textContent!==text)this.selection.textContent=text;
  if(this.stickyAdd.disabled!==this.native.disabled)this.stickyAdd.disabled=this.native.disabled;
  const label=this.native.textContent.trim();if(this.stickyAdd.textContent!==label)this.stickyAdd.textContent=label;
 }
 disconnectedCallback(){this.observer?.disconnect();window.removeEventListener('scroll',this.onScroll);cancelAnimationFrame(this.frame);this.root?.removeEventListener('change',this.onChange);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-drawer-refresh"] && !Shopify.designMode) return;
  try {
    (()=>{
 const enhance=()=>{
  document.querySelectorAll('.hs-popup-cart-sp-load').forEach(drawer=>{
   const buttons=drawer.querySelector('.hs-content-buttons');
   const template=document.getElementById('jb-drawer-link');
   if(buttons&&template&&!buttons.querySelector('.jb-drawer-view'))buttons.append(template.content.cloneNode(true));
   drawer.querySelectorAll('.hs-product-title').forEach(title=>{
    const text=title.textContent.trim();
    const short=text.split(' Scented Oils')[0].split(' Whipped Body Butter')[0];
    if(short&&short!==text){title.title=text;title.textContent=short;}
   });
  });
 };
 let scheduled=false;
 new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance();});}}).observe(document.documentElement,{childList:true,subtree:true});
 enhance();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-inspired-by"] && !Shopify.designMode) return;
  try {
    (() => {
    const sync = () => {
      document.querySelectorAll('.rm-pattern-badge-label').forEach(label => {
        const scope = label.closest('.product-grid-item, .product__info-container');
        const badge = label.closest('.rm-pattern-badge');
        if (badge && scope?.querySelector('.jb-inspiration') && /^inspired\s+by\b/i.test(label.textContent.trim())) {
          badge.classList.add('jb-legacy-inspiration');
        }
      });
    };
    sync();
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-load-more')) {
customElements.define('jb-load-more', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.grid = this.closest('#product-grid');
    this.row = this.grid?.querySelector('[data-product-column]');
    this.button = this.querySelector('button');
    if (!this.row || !this.button) return;
    this.ready = true;
    this.querySelector('.jb-load-more__enhanced').hidden = false;
    this.querySelector('.jb-load-more__fallback').hidden = true;
    this.button.addEventListener('click', event => this.load(event.detail === 0));
    this.updateCount();
  }
  disconnectedCallback() { this.controller?.abort(); }
  updateCount() {
    const count = this.row.children.length;
    this.querySelector('[role="status"]').textContent = this.dataset.countTemplate.replace('[count]', String(count));
    this.querySelector('progress').value = count;
    this.button.hidden = !this.dataset.next || count >= Number(this.dataset.total);
  }
  async load(keyboard) {
    if (this.busy || !this.dataset.next) return;
    const next = new URL(this.dataset.next, location.href);
    if (next.origin !== location.origin || !this.grid.dataset.id) return;
    next.searchParams.set('section_id', this.grid.dataset.id);
    const current = new URL(location.href);
    ['view','preview_theme_id'].forEach(key => { if(current.searchParams.has(key)) next.searchParams.set(key,current.searchParams.get(key)); });
    const pageState = location.pathname + location.search;
    this.busy = true;
    this.controller = new AbortController();
    this.button.disabled = true;
    this.button.setAttribute('aria-busy','true');
    const label = this.button.querySelector('span');
    const originalLabel = label.textContent;
    label.textContent = this.dataset.loading;
    const error = this.querySelector('.jb-load-more__error');
    error.hidden = true;
    try {
      const response = await fetch(next.href,{signal:this.controller.signal,credentials:'same-origin'});
      if(!response.ok) throw new Error('Request failed');
      const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
      if(!this.isConnected || pageState !== location.pathname + location.search) return;
      const newGrid = parsed.querySelector('#product-grid');
      const newRow = newGrid?.querySelector('[data-product-column]');
      const nextControl = newGrid?.querySelector('jb-load-more');
      if(!newRow || !newRow.children.length || !nextControl) throw new Error('Missing results');
      const existing = new Set(Array.from(this.row.children,card=>card.dataset.jbItem));
      const cards = Array.from(newRow.children).filter(card=>!existing.has(card.dataset.jbItem));
      if(!cards.length) throw new Error('No new results');
      const fragment = document.createDocumentFragment();
      cards.forEach(card=>fragment.appendChild(document.importNode(card,true)));
      const firstNewCard = fragment.firstElementChild;
      this.row.appendChild(fragment);
      this.dataset.next = nextControl.dataset.next || '';
      this.dataset.total = nextControl.dataset.total;
      error.querySelector('a').href = this.dataset.next || location.href;
      this.updateCount();
      this.dispatchEvent(new CustomEvent('jb:products-loaded',{bubbles:true,detail:{count:cards.length}}));
      if(keyboard) firstNewCard.querySelector('a')?.focus({preventScroll:true});
    } catch(failure) {
      if(failure.name !== 'AbortError' && this.isConnected) error.hidden = false;
    } finally {
      this.busy = false;
      if(this.isConnected) { this.button.disabled=false;this.button.removeAttribute('aria-busy');label.textContent=originalLabel; }
    }
  }
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-oil-bottle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jb-oil-bottle'))customElements.define('jb-oil-bottle',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  const root=document.querySelector('[data-section-id="'+this.dataset.section+'"]');if(!root)return;
  const picker=root.querySelector('variant-selects');if(!picker){this.hidden=true;return;}
  picker.after(this);
  const selects=Array.from(picker.querySelectorAll('select'));const size=selects.find(s=>s.name.toLowerCase().includes('size'));const priceRoot=root.querySelector('.product-price-and-quantity-container');
  const price=this.querySelector('[data-bottle-price]');const text=this.querySelector('[data-bottle-options]');const choices=this.querySelector('[data-size-choices]');
  const sync=()=>{text.textContent=selects.map(s=>s.selectedOptions[0]?.textContent.trim()).filter(Boolean).join(' · ');choices.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===size?.value)));};
  const syncPrice=()=>{const availablePrices=Array.from(priceRoot?.querySelectorAll('.price-item--sale,.price-item--regular')||[]).filter(e=>e.getClientRects().length);price.textContent=availablePrices[0]?.textContent.trim()||'';};
  if(size&&size.options.length>1){this.querySelector('details').hidden=false;Array.from(size.options).forEach(o=>{const b=document.createElement('button');b.type='button';b.dataset.value=o.value;b.textContent=o.textContent.trim();b.addEventListener('click',()=>{size.value=o.value;size.dispatchEvent(new Event('change',{bubbles:true}));});choices.appendChild(b);});}
  this.onChange=()=>{sync();price.textContent=this.dataset.updating;};picker.addEventListener('change',this.onChange);this.picker=picker;
  this.observer=new MutationObserver(syncPrice);if(priceRoot)this.observer.observe(priceRoot,{childList:true,subtree:true,characterData:true,attributes:true});sync();syncPrice();
 }
 disconnectedCallback(){if(this.isConnected)return;this.observer?.disconnect();this.picker?.removeEventListener('change',this.onChange);this.initialized=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-oil-experience"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jb-oil-experience'))customElements.define('jb-oil-experience',class extends HTMLElement{
 connectedCallback(){
  this.root=document.querySelector('[data-section-id="'+this.dataset.section+'"]');if(!this.root)return;
  this.info=this.root.querySelector('.product__info-container');this.bar=this.querySelector('.jb-oil-sticky');this.selection=this.querySelector('[data-selection]');
  const picker=this.root.querySelector('variant-selects,variant-radios');
  if(picker&&!this.info.querySelector('.jb-oil-option-note'))picker.before(this.querySelector('template[data-note]').content.cloneNode(true));
  const intro=this.querySelector('[data-scent-intro]');const title=this.root.querySelector('h1.product__title');if(intro&&title&&!this.root.querySelector('.jb-oil-scent-lead'))title.after(intro.content.cloneNode(true));const tone=this.querySelector('.jb-discover');if(tone){const style=getComputedStyle(tone);this.root.style.setProperty('--oil-accent',style.getPropertyValue('--oil-accent'));this.root.style.setProperty('--oil-ink',style.getPropertyValue('--oil-ink'));}
  const price=this.root.querySelector('.product-price-and-quantity-container');const families=this.root.querySelector('.jb-oil-families');if(price&&families)families.after(price);
  this.chips=[];this.root.querySelectorAll('variant-selects select').forEach(select=>{if(!select.name.toLowerCase().includes('usage')||select.options.length>6)return;const group=document.createElement('div');group.className='jb-oil-chips';group.setAttribute('role','group');group.setAttribute('aria-label',select.closest('.product-form__input').querySelector('label')?.textContent.trim()||select.name);Array.from(select.options).forEach(option=>{const b=document.createElement('button');b.type='button';b.textContent=option.textContent.trim();b.dataset.value=option.value;b.setAttribute('aria-pressed',String(select.value===option.value));b.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));this.sync();});group.appendChild(b);});select.closest('.select').after(group);select.closest('.select').classList.add('jb-oil-native');this.chips.push({select,group});});
  this.sync=()=>{const add=this.root.querySelector('product-form [name="add"]');this.bar.hidden=!add||add.getBoundingClientRect().bottom>=0;this.selection.textContent=Array.from(this.root.querySelectorAll('variant-selects select')).map(s=>s.selectedOptions[0]?.textContent.trim()).filter(Boolean).join(' · ');this.chips.forEach(({select,group})=>group.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value))));};
  this.useCards=Array.from(this.querySelectorAll('[data-oil-use]'));const usage=Array.from(this.root.querySelectorAll('variant-selects select')).find(s=>s.name.toLowerCase().includes('usage'));
  if(usage){const originalSync=this.sync;this.sync=()=>{originalSync();this.useCards.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.oilUse===usage.value)));};this.useCards.forEach(b=>b.addEventListener('click',()=>{usage.value=b.dataset.oilUse;usage.dispatchEvent(new Event('change',{bubbles:true}));this.sync();this.info.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});}));}
  this.onScroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.sync();});};
  window.addEventListener('scroll',this.onScroll,{passive:true});this.root.addEventListener('change',this.sync);this.sync();
 }
 disconnectedCallback(){window.removeEventListener('scroll',this.onScroll);this.root?.removeEventListener('change',this.sync);cancelAnimationFrame(this.frame);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-oil-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jb-oil-reviews'))customElements.define('jb-oil-reviews',class extends HTMLElement{
 connectedCallback(){
  const track=this.querySelector('.jb-review-track'),template=this.querySelector('template'),details=this.querySelector('details');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');let hovered=false,focused=false,touched=false,last=0,position=0,loop=0;
  const build=()=>{
   const source=document.querySelector('#ddReview');if(!source)return;
   const rows=Array.from(source.querySelectorAll('[class*="ListLayout_standard__"]'));if(!rows.length)return;
   this.observer.disconnect();
   rows.forEach(row=>{
    const quote=row.querySelector('[class*="CommonWidget_reviewContent"]')?.textContent.trim();
    const name=row.querySelector('[class*="ListLayout_nickAndArea"]>span')?.textContent.trim(),stars=row.querySelector('.rating-widget-dd');
    if(!quote||!name||!stars)return;
    const card=template.content.firstElementChild.cloneNode(true);
    card.querySelector('[data-author]').textContent=name;
    card.querySelector('[data-date]').textContent=row.querySelector('[class*="ListLayout_time"]')?.textContent.trim()||'';
    card.querySelector('[data-quote]').textContent=quote;
    card.querySelector('[data-stars]').append(stars.cloneNode(true));track.append(card);
   });
   this.hidden=false;details.append(source);
   const originals=Array.from(track.children);this.querySelector('.jb-review-controls').hidden=originals.length<2;
   if(originals.length>1){
    while(track.children.length<6)originals.forEach(card=>{const copy=card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a').forEach(a=>a.tabIndex=-1);track.append(copy);});
    const sequence=Array.from(track.children);sequence.forEach(card=>{const copy=card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a').forEach(a=>a.tabIndex=-1);track.append(copy);});
    this.measure=()=>{loop=track.children[sequence.length].offsetLeft-track.firstElementChild.offsetLeft;};this.resize=new ResizeObserver(this.measure);this.resize.observe(track);this.measure();
   }
   if(!originals.length){track.hidden=true;details.open=true;}
  };
  this.observer=new MutationObserver(build);this.observer.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});build();
  const move=direction=>{position=track.scrollLeft+direction*((track.firstElementChild?.getBoundingClientRect().width||0)+18);if(loop)position=(position+loop)%loop;track.scrollLeft=position;};
  this.querySelector('[data-prev]').onclick=()=>move(-1);this.querySelector('[data-next]').onclick=()=>move(1);
  this.onmouseenter=()=>hovered=true;this.onmouseleave=()=>hovered=false;this.onfocusin=()=>focused=true;this.onfocusout=e=>focused=this.contains(e.relatedTarget);this.ontouchstart=()=>touched=true;this.ontouchend=()=>touched=false;this.ontouchcancel=()=>touched=false;
  this.openReviews=e=>{const link=e.target.closest('a[href*="#ddReview"]');if(link){details.open=true;}};document.addEventListener('click',this.openReviews);
  const frame=time=>{const delta=Math.min(time-last,50);last=time;const r=track.getBoundingClientRect();
   if(loop&&!hovered&&!focused&&!touched&&!document.hidden&&!reduced.matches&&r.top<innerHeight&&r.bottom>0){position=(position+delta*.018)%loop;track.scrollLeft=position;}else position=track.scrollLeft;
   this.frame=requestAnimationFrame(frame);
  };this.frame=requestAnimationFrame(frame);
 }
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.resize?.disconnect();document.removeEventListener('click',this.openReviews);}
});
  } catch(e) { console.error(e); }
})();

})();
